export default __webpack_public_path__ + "static/Kokito-4292b02f99d81544c376772869878580.png";